// extracted by mini-css-extract-plugin
export default {"overlay":"social-ugc-actions-SocialFab__overlay--31Qvx"};